import ContainerTypeLabel from "./container-type-label.component";

export default ContainerTypeLabel;
